import React from 'react'
import { useMenuSearchContext } from './MenuSearchContext'
import { LookupInfoIcon, SearchIcon } from '@toasttab/buffet-pui-icons'
import { t } from 'src/translations/src/utilities'

export const RecentSearches = () => {
  const {
    recentSearches,
    clearRecentSearches,
    setSearchString,
    setFromRecentSearches
  } = useMenuSearchContext()

  const onRecentSearchClick = (search: string) => {
    setSearchString(search)
    setFromRecentSearches(true)
  }

  return recentSearches.length > 0 ? (
    <div className='recent-searches'>
      <div className='recent-searches-header'>
        <h3>{t('menu-banner.search-recent')}</h3>
        <button
          className='clear-all-button'
          onClick={() => {
            clearRecentSearches()
          }}
        >
          {t('menu-banner.search-clear-recent')}
        </button>
      </div>
      <ul>
        {recentSearches.map((search, index) => (
          <li key={index}>
            <button onClick={() => onRecentSearchClick(search)}>
              <span className='search-icon'>
                <SearchIcon />
              </span>
              {search}
            </button>
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <div className='search-placeholder'>
      <LookupInfoIcon />
      <p>{t('menu-banner.search-initial-state')}</p>
      <p className='search-subheader'>
        {t('menu-banner.search-initial-state.subheader')}
      </p>
    </div>
  )
}
